import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from 'stores/RootReducer/rootReducer';

import App from './App';
import AppInitialize from './AppInitialize';
import * as serviceWorker from 'serviceWorker';
import { PermissionsProvider } from './contexts/core/PermissionsContext';
import { PaymentMethodProvider } from './contexts/PaymentMethodContext';

store.subscribe(() => {});

ReactDOM.render(
  <Router>
    <PermissionsProvider initialPermissions={[]}>
      <Provider store={store}>
        <AppInitialize>
          {/* <PermissionsChecker>  */}
          <PaymentMethodProvider>
            <App />
          </PaymentMethodProvider>
          {/* </PermissionsChecker> */}
        </AppInitialize>
      </Provider>
    </PermissionsProvider>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
